import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fromEvent } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';

export interface WidgetGroupItem {
    label: string;
    total: number;
}

@UntilDestroy()
@Component({
    selector: 'app-widget-group',
    templateUrl: './widget-group.component.html',
    styleUrls: ['./widget-group.component.scss'],
})
export class AppWidgetGroupComponent<T> implements OnInit, OnChanges, AfterViewInit
{
    @Input() data: T[];
    @Input() labelKey = 'label';
    @Input() totalKey = 'total';

    @Output() widgetSelected: EventEmitter<WidgetGroupItem> = new EventEmitter<WidgetGroupItem>();

    @HostBinding('class.two-grid-layout') twoGridLayout = false;

    isLoadingInitialData = true;
    containerWidth = 0;
    widgets: WidgetGroupItem[] = [];
    widgetIndex = 0;
    selectedWidget: SelectionModel<WidgetGroupItem> = new SelectionModel<WidgetGroupItem>(null);

    private _elementRef: ElementRef;

    constructor(_elementRef: ElementRef) {
        this._elementRef = _elementRef;
    }

    get lastPage() {
        return this.widgetIndex + (this.twoGridLayout ? 2 : 4) > this.widgets.length - 1;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.hasOwnProperty('data') && this.data) {
            this.widgets = [
                ...this.data.map((item) => {
                    return {
                        label: item[this.labelKey],
                        total: item[this.totalKey],
                    } as WidgetGroupItem;
                })
            ];
            this.isLoadingInitialData = false;
        }
    }

    ngOnInit() {
        fromEvent(window, 'resize').pipe(untilDestroyed(this)).subscribe(() => this.updateContainerWidth());
    }

    ngAfterViewInit() {
        setTimeout(() => this.updateContainerWidth());
    }

    updateContainerWidth() {
        this.containerWidth = this._elementRef.nativeElement.clientWidth;
        this.twoGridLayout = this.containerWidth < 768;
    }

    prevSet() {
        const newIndex = this.widgetIndex - (this.twoGridLayout ? 2 : 4);
        this.widgetIndex = newIndex >= 0 ? newIndex : 0;
    }

    nextSet() {
        const newIndex = this.widgetIndex + (this.twoGridLayout ? 2 : 4);
        this.widgetIndex = newIndex <= this.widgets.length - 1 ? newIndex : this.widgets.length - 1;
    }

    toggleWidget(widget: WidgetGroupItem) {
        if (this.selectedWidget.isSelected(widget)) {
            return;
        }

        this.selectedWidget.select(widget);
        this.widgetSelected.emit(widget);
    }
}
